/**
 * created by athukorala on 11/18/19
 */
import React, {Component} from 'react';
import success_icon from "../../../../assets/img/sweet/success.svg";
import error_icon from "../../../../assets/img/sweet/cry.svg";
import {Col, Row} from "reactstrap";
import './CompareModal.css'

class App extends Component {
  render() {
    // console.log("enter",this.props.enter);
    // console.log("db",this.props.db);
    let entered = this.props.enter;
    let exist = this.props.db.visitor;
    let isCheck = false;
    if(entered.visitor_id === 0){
      isCheck = true;
    }
    let v_fname = ""; let v_lname="";
    let e_fname = ""; let e_lname="";

    if(entered.visitor_fname === null){
      v_fname = "";
    }else{
      v_fname = entered.visitor_fname
    }
    if(entered.visitor_lname === null){
      v_lname = "";
    }else{
      v_lname = entered.visitor_lname;
    }
    if(exist.firstName === null){
      e_fname = ""
    }else{
      e_fname = exist.firstName
    }

    if(exist.lastName === null){
      e_lname = ""
    }else{
      e_lname = exist.lastName
    }

    return (
      <div className="swal-overlay swal-overlay--show-modal" tabIndex="-1">
        <div className="swal-modal cmpr-modal-main" role="dialog" aria-modal="true">
          {
            this.props.type !== 2 ?
              <div className="swal-icon swal-icon--custom">
                <img src={
                  this.props.type === 0 ? success_icon : this.props.type === 1 ? error_icon : null
                }/>
              </div>:null
          }

          <div className="swal-title">
            {
              this.props.warning
            }
          </div>
          <div className={"cmpr-modal-wrapper"}>
            <Row>
              <Col xs="12" lg={"6"} md={"6"} className={"cmpr-modal-enter-value-col"}>
                <h5 className={"cmpr-modal-viewer cmpr-modal-text"}>
                  Entered details
                </h5>
                <div className={"cmpr-modal-viewer"}>
                  <h5 className="cmpr-modal-text">{entered.visitor_identify === null ? "Identity : ":"Identity : "+entered.visitor_identify}</h5>
                  <h5 className="cmpr-modal-text">{"Name : "+v_fname + " "+v_lname}</h5>
                  <h5 className="cmpr-modal-text">{entered.visitor_title === null ? "Title : ":"Title : "+entered.visitor_title}</h5>
                  <h5 className="cmpr-modal-text">{entered.visitor_mobile === null ? "Mobile : ":"Mobile : "+entered.visitor_mobile}</h5>
                  <h5 className="cmpr-modal-text">{entered.visitor_company === null ? "Company : ":"Company : "+entered.visitor_company}</h5>
                  <h5 className="cmpr-modal-text">{entered.visitor_email === null ? "Email : ":"Email : "+entered.visitor_email}</h5>
                </div>

              </Col>
              <Col xs="12" lg={"6"} md={"6"} className={"cmpr-modal-db-value-col"}>
                <h5 className={"cmpr-modal-viewer cmpr-modal-text"}>
                  Existing user details
                </h5>
                <div className={"cmpr-modal-viewer"}>
                  <h5 className="cmpr-modal-text">{exist.identificationValue === null ? "Identity : ": "Identity : "+exist.identificationValue}</h5>
                  <h5 className="cmpr-modal-text">{"Name : "+e_fname + " "+e_lname}</h5>
                  <h5 className="cmpr-modal-text">{exist.title === null ? "Title : ":"Title : "+exist.title}</h5>
                  <h5 className="cmpr-modal-text">{exist.mobile === null ? "Mobile : ":"Mobile : "+exist.mobile}</h5>
                  <h5 className="cmpr-modal-text">{exist.companyName === null ?"Company : ":"Company : "+exist.companyName}</h5>
                  <h5 className="cmpr-modal-text">{exist.email === null ?"Email : ":"Email : "+exist.email}</h5>
                </div>
              </Col>
            </Row>
          </div>
          <h5 className={"cmpr-modal-question"}>{isCheck ? "Do you wish to update existing details?":"This user account already exists. Can't add this visitor"}</h5>
          <div className="swal-footer">
            {
              isCheck ?
                <div className="swal-button-container">

                  <button className="swal-button swal-button--cancel" onClick={this.props.closeHandler}>No</button>

                  <div className="swal-button__loader">
                    <div/>
                    <div/>
                    <div/>
                  </div>
                  <div className="swal-button-container">

                    <button className="swal-button swal-button--dangerMode okay-btn" onClick={this.props.yesHandler}>Yes</button>

                    <div className="swal-button__loader">
                      <div/>
                      <div/>
                      <div/>
                    </div>

                  </div>
                </div>:
                <div className="swal-button-container">

                  <div className="swal-button-container">

                    <button className="swal-button swal-button--dangerMode okay-btn" onClick={this.props.closeHandler}>Okay</button>

                    <div className="swal-button__loader">
                      <div/>
                      <div/>
                      <div/>
                    </div>

                  </div>
                </div>
            }

          </div>
        </div>
      </div>
    );
  }
}

export default App;
